// extracted by mini-css-extract-plugin
export default {"whatIsPaysContainer":"WhatIsPays_whatIsPaysContainer__I9hId","whatIsPays":"WhatIsPays_whatIsPays__7XsK9"};